"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var getCurrentBlockquote_1 = __importDefault(require("./getCurrentBlockquote"));
/**
 * Is the selection in a blockquote
 */
var isSelectionInBlockquote = function (opts) { return function (value) {
    return Boolean(getCurrentBlockquote_1.default(opts)(value));
}; };
exports.default = isSelectionInBlockquote;
//# sourceMappingURL=isSelectionInBlockquote.js.map